import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Copyrightpolicy() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
  
    <Helmet>
        <title>Copyright Policy - EditorTask</title>
        <meta name="description" content="Read EditorTask’s copyright policy to understand how we handle intellectual property, protect user-generated content, and respond to infringement claims." />
        <meta name="keywords" content="copyright policy, intellectual property, content rights, DMCA, infringement, user content policy, editor task" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Copyright Policy - EditorTask" />
        <meta property="og:description" content="Learn about EditorTask’s copyright and intellectual property policy. See how we protect original content and handle infringement issues." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className="container_size">
        <h2 className="contact-title">Copyright Policy</h2>

        <div className="page-content">
          <p>
            EditorTask respects the intellectual property rights of others and expects users of the platform to do the same. This Copyright Policy outlines how we handle copyright claims and user-generated content on our platform.
          </p>

          <h2>1. User Responsibility</h2>
          <p>
            By uploading or posting content on EditorTask, you confirm that you own the rights to such content or have proper authorization to share it. Users are fully responsible for the content they post, including text, images, videos, and any media files.
          </p>

          <h2>2. Copyright Infringement</h2>
          <p>
            If you believe that your copyrighted work has been used or shared on EditorTask without authorization, please notify us by providing the following information:
            <ul>
              <li>Full name and contact information</li>
              <li>Identification of the copyrighted work</li>
              <li>Details of the infringing material and its URL</li>
              <li>A statement that you believe in good faith that the use is unauthorized</li>
              <li>Your signature or digital signature</li>
            </ul>
            Email this information to: <a href="mailto:copyright@editortask.com">copyright@editortask.com</a>
          </p>

          <h2>3. Content Removal</h2>
          <p>
            Upon receiving a valid copyright complaint, we will investigate and may remove or disable access to the allegedly infringing material. We also reserve the right to take appropriate action against repeat offenders, including account suspension or termination.
          </p>

          <h2>4. Counter-Notice</h2>
          <p>
            If you believe content was removed in error, you may submit a counter-notice with valid details to dispute the claim. We will forward this to the complainant and, unless legal action is initiated, may restore the content after 10–14 business days.
          </p>

          <h2>5. Policy Updates</h2>
          <p>
            We may update this policy from time to time. We recommend users check this page periodically to stay informed about our content practices.
          </p>

          <p>
            Thank you for respecting copyrights and helping us keep EditorTask a professional and creative platform.
          </p>
        </div>
      </div>
      </div>
</div>
    );
}
